import { CircularProgress } from "@mui/material"

import { colors } from "@/components/colors"

export default function LoadingSpinner() {
  return (
    <CircularProgress
      size={40}
      sx={() => ({
        color: colors.neutral.grey[800],
      })}
    />
  )
}
